import { makeStyles } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import React, { useCallback, useContext } from 'react';

import { TrainersContext } from '../trainers.context';
import TrainerForm from './TrainerForm';

const useStyles = makeStyles(theme => ({
  fabButton: {
    width: 40,
    height: 40,
    color: 'white',
    float: 'right',
    marginRight: '5px',
    marginTop: '-92px',
    backgroundColor: theme.palette.error.main,
  },
  addButton: {
    width: '21px',
    height: '21px',
  },
}));

export default function TrainerAdd() {
  const classes = useStyles();
  const { setNewDialogOpened, newDialogOpened, reload } = useContext(TrainersContext);
  const closeDialog = useCallback(
    success => {
      setNewDialogOpened(false);

      if (success) {
        reload();
      }
    },
    [reload, setNewDialogOpened]
  );
  const onClick = useCallback(() => {
    setNewDialogOpened(true);
  }, [setNewDialogOpened]);

  return (
    <>
      <Fab onClick={onClick} className={classes.fabButton}>
        <AddIcon className={classes.addButton} />
      </Fab>
      <TrainerForm onClose={closeDialog} data={null} open={newDialogOpened} />
    </>
  );
}
